import { Box, Button, Container, Typography, Grid } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./MsWellDoneScreen.css";
import { useConfig } from "../../contexts/ConfigContext";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { useAppTheme } from "../../theme/useTheme";

function MsWellDoneScreen() {
  const theme = useAppTheme();
  const { config } = useConfig();
  return (
    <Grid className="ms-set-password-container ms-well-done-screen">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        {theme?.assets?.logo && <img src={theme.assets.logo} alt="Worldline" />}
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        {theme?.assets?.rightCircle && <img src={theme.assets.rightCircle} alt="right-circular-gradient" />}
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box alignItems="center" textAlign="center">
            <CheckCircleIcon className="ms-success-icon" />
            <Typography
              variant="h5"
              fontWeight="600"
              gutterBottom
              className="ms-set-password-title"
              style={{ marginTop: "32px", marginBottom: "8px" }}
            >
              <Translate tKey={T_KEYS.MS.WELL_DONE.HEADER} />
            </Typography>
            <Typography variant="body1" gutterBottom className="ms-set-password-description">
              <Translate tKey={T_KEYS.MS.WELL_DONE.BODY} />
            </Typography>

            <form noValidate>
              <Button
                variant="contained"
                color="primary"
                className="ms-login-button"
                fullWidth
                sx={{ mt: 3 }}
                onClick={() => (window.location.href = config?.reportalLoginUrlMS1)}
              >
                <Translate tKey={T_KEYS.MS.LOGIN_BUTTON} />
              </Button>
            </form>
          </Box>
        </Container>
      </div>
    </Grid>
  );
}

export default MsWellDoneScreen;
